import { useState } from 'react'
import { toast } from 'react-toastify'
import ModalHistoryOrder from '@/entities/profile-page/historyOrders/ModalHistoryOrder/index.js'
import ModalCancelOrder from '@/entities/profile-page/historyOrders/ModalCancelOrder/index.js'
import { useCancelOrderMutation } from '@/shared/api-rtk/index.js'

export const CardOrder = ({ orderData, onOrderUpdated }) => {
    const [showModalHistoryOrder, setShowModalHistoryOrder] = useState(false)
    const [showCancelModal, setShowCancelModal] = useState(false)
    const [cancelOrder, { isLoading }] = useCancelOrderMutation()

    const orderDate = orderData.date_added.split(' ').reverse().join(' ')
    const addressDelivery =
        orderData.payment_zone + ', ' + orderData.shipping_address_1
    const totalPrice = Math.round(orderData.total).toLocaleString('RU-ru')

    // Приводим значения к числу для надежного сравнения
    const newStatusOrder = Number(orderData.new_status_order)
    const newStatusDelivery = Number(orderData.new_status_delivery)
    const newStatusPayment = Number(orderData.new_status_payment)

    // Проверка - можно ли отменить заказ
    // Заказ НЕЛЬЗЯ отменить, если:
    // - статус заказа: 20 или 30
    // - статус доставки: 60 или 70
    // - статус оплаты: 100
    const cannotCancel = newStatusOrder === 20 || 
                         newStatusOrder === 30 ||
                         newStatusDelivery === 60 ||
                         newStatusDelivery === 70 ||
                         newStatusPayment === 100

    // Кнопка отмены доступна только если заказ можно отменить
    const canCancel = !cannotCancel

    // Получаем названия статусов из данных
    const statusOrder = orderData.status_name || '—'
    const statusDelivery = orderData.delivery_status_name || '—'
    const statusPayment = orderData.payment_status_name || '—'

    // Код получения Яндекс Доставка (если есть)
    const pickupCode = orderData.pickup_code || null

    const handleCancelClick = (e) => {
        e.stopPropagation()
        setShowCancelModal(true)
    }

    const handleCancelConfirm = async () => {
        try {
            const result = await cancelOrder({
                order_id: orderData.order_id,
                customer_id: orderData.customer_id
            }).unwrap()
            
            if (result.data) {
                toast.success('Заказ успешно отменен')
                setShowCancelModal(false)
                
                // Обновляем данные заказа в родительском компоненте
                if (onOrderUpdated) {
                    onOrderUpdated(orderData.order_id)
                }
                
                // Перезагружаем страницу или обновляем список заказов
                window.location.reload()
            }
        } catch (error) {
            console.error('Ошибка при отмене заказа:', error)
            toast.error(error?.data?.error || 'Не удалось отменить заказ')
        }
    }

    const handleCancelClose = () => {
        setShowCancelModal(false)
    }

    return (
        <div className={'CardOrder'}>
            <div className={'header'}>
                <div className="header-left">
                    <h2>Заказ №{orderData.order_id}</h2>
                    {canCancel && (
                        <button 
                            className="return-button"
                            onClick={handleCancelClick}
                            disabled={isLoading}
                        >
                            {isLoading ? 'Отмена...' : 'Отменить'}
                        </button>
                    )}
                    {/* Код получения - в одной строке с номером */}
                    {pickupCode && (
                        <span className="pickup-code-inline">
                            Код получения: <strong>{pickupCode}</strong>
                        </span>
                    )}
                </div>
                <span>{statusOrder}</span>
            </div>
            
            <div className={'main'}>
                <div className={'row-item'}>
                    <h3>Дата заказа:</h3>
                    <p>{orderDate}</p>
                </div>
                <div className={'row-item'}>
                    <h3>Адрес доставки:</h3>
                    <p>{addressDelivery}</p>
                </div>
                <div className={'row-item'}>
                    <h3>Сумма заказа:</h3>
                    <p>{totalPrice} ₽</p>
                </div>
                <div className={'row-item'}>
                    <h3>Статус доставки:</h3>
                    <p>{statusDelivery}</p>
                </div>
                <div className={'row-item'}>
                    <h3>Статус оплаты:</h3>
                    <p>{statusPayment}</p>
                </div>
            </div>
            <div
                className={'action'}
                onClick={() => setShowModalHistoryOrder(true)}
            >
                <span>Товаров: {orderData.products_count}</span>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="6"
                    height="10"
                    viewBox="0 0 6 10"
                    fill="none"
                >
                    <path
                        d="M1 0.854492L5 4.85449L1 8.85449"
                        stroke="white"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            </div>

            {/* Модальное окно для отмены заказа */}
            <ModalCancelOrder
                show={showCancelModal}
                onHide={handleCancelClose}
                onConfirm={handleCancelConfirm}
                deliveryStatus={newStatusDelivery}
                orderId={orderData.order_id}
                isLoading={isLoading}
            />

            <ModalHistoryOrder
                show={showModalHistoryOrder}
                onHide={() => setShowModalHistoryOrder(false)}
                orderId={orderData.order_id}
                statusOrder={statusOrder}
            />
        </div>
    )
}